import React from 'react';
import mapKeys from 'lodash/mapKeys';
import camelCase from 'lodash/camelCase';

import Colors from 'Wpds/colors/ColorConstants';
import WpIcon from 'Wpds/components/icon/WpIcon';
import { unixDateMMMDDYYYY } from 'Shared/utils/DateTime.utils';

import './MeetingItemHistoryItem.scss';

type Props = {
  item: {
    userName: string;
    userId: number;
    timestamp: number;
    changeType: string;
    assigneeName: string | number;
    before?: number;
    after?: number;
  };
};

const getDetails = ({ item }: Props) => {
  const standardizedItem = mapKeys(item, (v, k) => camelCase(k));
  const name = standardizedItem.userName;
  const timestamp = (
    <span className="MeetingItemHistoryItem__item__label__time">{unixDateMMMDDYYYY(standardizedItem.timestamp)}</span>
  );

  switch (standardizedItem.changeType) {
    case 'assigned':
      return (
        <div className="MeetingItemHistoryItem__item">
          <div className="MeetingItemHistoryItem__item__label">
            <span className="MeetingItemHistoryItem__item__label__bold">{name}</span> assigned the item to{' '}
            {standardizedItem.assigneeName} - {timestamp}
          </div>
        </div>
      );
    case 'unassigned':
      return (
        <div className="MeetingItemHistoryItem__item">
          <div className="MeetingItemHistoryItem__item__label">
            <span className="MeetingItemHistoryItem__item__label__bold">{standardizedItem.assigneeName}</span>{' '}
            unassigned the item from {name} - {timestamp}
          </div>
        </div>
      );
    case 'uncompleted':
      return (
        <div className="MeetingItemHistoryItem__item">
          <div className="MeetingItemHistoryItem__item__label">
            <span className="MeetingItemHistoryItem__item__label__bold">{name}</span> marked item incomplete -{' '}
            {timestamp}
          </div>
        </div>
      );
    case 'completed':
      return (
        <div className="MeetingItemHistoryItem__item">
          <div className="MeetingItemHistoryItem__item__label">
            <span className="MeetingItemHistoryItem__item__label__bold">{name}</span> marked item complete - {timestamp}
          </div>
        </div>
      );
    case 'changed_body':
      return (
        <div className="MeetingItemHistoryItem__item">
          <div className="MeetingItemHistoryItem__item__label">
            <span className="MeetingItemHistoryItem__item__label__bold">{name}</span> edited the description -{' '}
            {timestamp}
          </div>
        </div>
      );
    case 'set_due_date':
    case 'unset_due_date':
      return (
        <div className="MeetingItemHistoryItem__item">
          <div className="MeetingItemHistoryItem__item__label">
            <span className="MeetingItemHistoryItem__item__label__bold">{name}</span> changed the due date - {timestamp}
          </div>
          <div className="MeetingItemHistoryItem__item__value">
            <span className="MeetingItemHistoryItem__item__value__before">
              {standardizedItem.before ? unixDateMMMDDYYYY(standardizedItem.before) : 'not set'}
            </span>
            <span className="MeetingItemHistoryItem__item__value__arrow">
              <WpIcon name="arrow-right" color={Colors.gray[700]} />
            </span>
            <span className="MeetingItemHistoryItem__item__value__after">
              {standardizedItem.after ? unixDateMMMDDYYYY(standardizedItem.after) : 'not set'}
            </span>
          </div>
        </div>
      );

    default:
      return false;
  }
};

const MeetingItemHistoryItem = ({ item }: Props) => {
  return <div className="MeetingItemHistoryItem">{getDetails({ item })}</div>;
};

export default MeetingItemHistoryItem;
